export const AUDIO_PLAYER_SIZE = 48;
export const AUDIO_PLAYER_BAR_WIDTH = 4;
export const AUDIO_PLAYER_BAR_SPACING = 2;
